import { IResultWithPagination } from 'reducers/models';
import { IDocument } from 'reducers/fact/models';

export interface IDocuments extends IResultWithPagination<IDocument> { }

export interface IEquipments {
    equipmentId: number;
    equipmentNumber: string;
    status: string;
    sealNumber: string;
    type: string;
    size: number;
    subType: string;
    subSize: string;
    equipmentTotalVolume: string;
    quantity: string;
    weight: string;
    packages: string;
    documentOnEquipmentVolume: string;
    etOnEssoVolumeFactor: string;
    essoOnEtVolumeFactor: string;
    createDate: string;
    updateDate: string;
}
export interface IEquipments {
    equipmentId: number;
    equipmentNumber: string;
    status: string;
    sealNumber: string;
    type: string;
    size: number;
    subType: string;
    subSize: string;
    equipmentTotalVolume: string;
    quantity: string;
    weight: string;
    packages: string;
    documentOnEquipmentVolume: string;
    etOnEssoVolumeFactor: string;
    essoOnEtVolumeFactor: string;
    createDate: string;
    updateDate: string;
}
export interface IVoyages {
    voyageId: number;
    voyageNumber: string;
    vesselCode: string;
    vesselName: string;
    loadingPortName: string;
    loadingPortCode: string;
    destinationPortName: string;
    destinationPortCode: string;
    eta: string;
    etd: string;
    ata: string;
    atd: string;
    type: string;
}
export interface ITransportPlanLegVoyage {
    voyageId: number;
    voyageNumber: string;
    vesselCode: string;
    vesselName: string;
    vesselType: string;
    legSequence: number;
}
export interface IDocumentDetail {
    id: number;
    exportJobId: number;
    finNumber: string;
    notificationIndicator: boolean;
    exportJobNumber: string;
    originalDocumentNumber: string;
    type: string;
    issuerCountryCode: string;
    issuerBECode: string;
    issuerName: string;
    issuerFactCode: string;
    issuerSCVCode: string;
    issuerFunctionCode: string;
    consigneeCountryCode: string;
    consigneeBusinessEntityCode: string;
    consigneeName: string;
    consigneeFactCode: string;
    consigneeSCVCode: number;
    invoiceeCountryCode: string;
    finOpsStatus: string;
    opsStatus: string;
    status: string;
    incoTerms: string;
    shipmentType: string;
    invoiceeBusinessEntityCode: string;
    invoiceeName: string;
    invoiceeFactCode: string;
    invoiceeSCVCode: number;
    shipperCountryCode: string;
    shipperBusinessEntityCode: string;
    shipperName: string;
    shipperFACTCode: string;
    shipperSCVCode: number;
    placeOfReceiptCode: string;
    placeOfReceiptName: string;
    placeOfDeliveryCode: string;
    placeOfDeliveryName: string;
    portOfLoadingCode: string;
    portOfLoadingName: string;
    portOfDischargeCode: string;
    portOfDischargeName: string;
    prepaidCollectIndicator: string;
    estimatedDeliveryTime: string;
    etd: string;
    goodsReceiptDate: string;
    serviceAtOrigin: string;
    serviceAtDestination: string;
    approverUserCompanyWideCode: string;
    changeUserCompanyWideCode: string;
    changeReason: string;
    createDate: string;
    lastUpdateDate: string;
    isCancelled: boolean;
    quantity: string;
    weight: string;
    volume: string;
    packages: string;
    originTrucking: string;
    originCustomsClearance: string;
    verifiedGrossMass: string;
    destinationTrucking: string;
    importerSecurityFiling: string;
    destinationCustoms: string;
    clearance: string;
    companyCode: string;
    plant: string;
    salesArea: string;
    salesDocumentCurrency: string;
    salesDocumentNetValue: number;
    salesDocumentType: string;
    salesOrderNumber: string;
    purchaseOrganisation: string;
    originOffice: string;
    destinationOffice: string;
    billingDocuments: any[];
    customerInvoice: any[];
    equipments: IEquipments[] | any[];
    purchaseOrderNumbers: any[];
    voyages: IVoyages[];
    transportPlanLegVoyages?: ITransportPlanLegVoyage[];
    bookings: any[];
    cbls: any[];
    clrs: any[];
    essos: any[];
    asns: any[];
    rateErrorMessage?: string;
    equipmentTransportShipments: any[];
    incoTerm: string;
}

export const EmptyDocumentDetail: IDocumentDetail = {
    id: 0,
    exportJobId: 0,
    notificationIndicator: false,
    exportJobNumber: '',
    finNumber: '',
    originalDocumentNumber: '',
    rateErrorMessage: '',
    type: '',
    issuerCountryCode: '',
    issuerBECode: '',
    issuerName: '',
    issuerFactCode: '',
    issuerSCVCode: '',
    issuerFunctionCode: '',
    consigneeCountryCode: '',
    consigneeBusinessEntityCode: '',
    consigneeName: '',
    consigneeFactCode: '',
    consigneeSCVCode: 0,
    invoiceeCountryCode: '',
    finOpsStatus: '',
    opsStatus: '',
    status: '',
    incoTerms: '',
    shipmentType: '',
    invoiceeBusinessEntityCode: '',
    invoiceeName: '',
    invoiceeFactCode: '',
    invoiceeSCVCode: 0,
    shipperCountryCode: '',
    shipperBusinessEntityCode: '',
    shipperName: '',
    shipperFACTCode: '',
    shipperSCVCode: 0,
    placeOfReceiptCode: '',
    placeOfReceiptName: '',
    placeOfDeliveryCode: '',
    placeOfDeliveryName: '',
    portOfLoadingCode: '',
    portOfLoadingName: '',
    portOfDischargeCode: '',
    portOfDischargeName: '',
    prepaidCollectIndicator: '',
    estimatedDeliveryTime: '',
    etd: '',
    goodsReceiptDate: '',
    serviceAtOrigin: '',
    serviceAtDestination: '',
    approverUserCompanyWideCode: '',
    changeUserCompanyWideCode: '',
    changeReason: '',
    createDate: '',
    lastUpdateDate: '',
    isCancelled: false,
    quantity: '',
    weight: '',
    volume: '',
    packages: '',
    originTrucking: '',
    originCustomsClearance: '',
    verifiedGrossMass: '',
    destinationTrucking: '',
    importerSecurityFiling: '',
    destinationCustoms: '',
    clearance: '',
    companyCode: '',
    plant: '',
    salesArea: '',
    salesDocumentCurrency: '',
    salesDocumentNetValue: 0,
    salesDocumentType: '',
    salesOrderNumber: '',
    purchaseOrganisation: '',
    originOffice: '',
    destinationOffice: '',
    billingDocuments: [],
    customerInvoice: [],
    equipments: [],
    purchaseOrderNumbers: [],
    voyages: [],
    clrs: [],
    bookings: [{

    }],
    cbls: [{

    }],
    essos: [{

    }],
    asns: [{

    }],
    equipmentTransportShipments: [{

    }],
    incoTerm: ''
};
